import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

/**
 * Strona grup jednego poziomu z TEMPTABLE (duckQueryTempTableGroups).
 * Rozwinięcie grupy, która nie jest ostatnim poziomem = to samo wywołanie z dłuższą ścieżką `GroupKeys`.
 * Wiersze grupy ostatniego poziomu pobiera getPaginatedData z `GroupKeys`.
 * @param {Object} body
 * @param {string} body.ResultID
 * @param {Array<string|{field: string, Buckets: Array<{type: string, value: *}>, Rest: boolean, NullGroup: boolean}>} body.GroupFields
 *        1..5, kolejność = poziomy. Poziom z `Buckets` (warunki jak w `Filter`) grupuje po przedziałach:
 *        klucz grupy i wartość w `GroupKeys` to indeks przedziału, N = "Pozostałe" (`Rest`), N+1 = puste (`NullGroup`)
 * @param {Array<{field: string, value: *}>} [body.GroupKeys] ścieżka otwartej grupy
 * @param {Array} [body.Filter] ten sam format co w getPaginatedData
 * @param {{by?: string, direction?: string, customSort?: string}} [body.GroupSort]
 * @param {Array<{type: string, column: string, name: string, weightColumn?: string}>} [body.Aggregations]
 * @param {number} [body.StartOffset]
 * @param {number} [body.RecordsCount]
 * @param {boolean} [body.IncludeTotal] wiersz "Razem" - tylko poziom 0, pierwsza strona
 */
export function getGroupedData(
    {
        ResultID,
        GroupFields,
        GroupKeys,
        Filter,
        GroupSort,
        Aggregations,
        StartOffset,
        RecordsCount,
        IncludeTotal,
    },
    {FarmID, ClientID, LocalUserID} = {}
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.getGroupedData({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: {
            ResultID,
            GroupFields,
            GroupKeys,
            Filter,
            GroupSort,
            Aggregations,
            StartOffset,
            RecordsCount,
            IncludeTotal,
        },
    });
}
